/** Logs de diagnóstico dos campos customizados (solicitação). */
const PREFIX = "[CustomFields]";

export function isFieldDefinitionsDebugEnabled() {
  if (process.env.NODE_ENV === "development") return true;
  try {
    return localStorage.getItem("DEBUG_FIELD_DEFINITIONS") === "1";
  } catch {
    return false;
  }
}

export function logFieldDefinitions(stage, detail = {}) {
  if (!isFieldDefinitionsDebugEnabled()) return;
  try {
    console.log(PREFIX, stage, detail);
  } catch (_) {
    /* ignore */
  }
}

/** Resumo seguro para log (sem valores grandes). */
export function summarizeFieldDefsPayload(raw) {
  if (raw == null) return { kind: "null" };
  if (Array.isArray(raw)) {
    return {
      kind: "array",
      length: raw.length,
      keys: raw.slice(0, 8).map((d) => d?.key),
    };
  }
  if (typeof raw !== "object") {
    return { kind: typeof raw, value: String(raw).slice(0, 80) };
  }
  return {
    kind: "object",
    topKeys: Object.keys(raw),
    hasRequest: Array.isArray(raw.request),
    requestLen: Array.isArray(raw.request) ? raw.request.length : 0,
    requestVisible: Array.isArray(raw.request)
      ? raw.request.filter((d) => d?.visible !== false).map((d) => d?.key)
      : [],
    hasNestedData: raw.data != null,
    nestedDataKeys:
      raw.data && typeof raw.data === "object" && !Array.isArray(raw.data)
        ? Object.keys(raw.data)
        : [],
  };
}
